<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1050px"
      show-save-button
      unit="互动信息"
    
     
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="信息类型">
              建议
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="信息标题">
             平台外链问题
            </el-form-item>
          </el-col>
        </el-row>
        
        
       
        <el-row>
          <el-col :span="24">
            <el-form-item label="情况描述">
             链接错误，打不开
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row>

           <el-col :span="isMB?24:12">
            <el-form-item label="提交商家">
             达信
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="提交时间">
             2024-03-21 10:01:12
            </el-form-item>
          </el-col>
          
        </el-row>

        <el-row>
          
          <el-col :span="isMB?24:12">
            <el-form-item label="状态">
              <span  style="color:#f11;">未答复</span>
            
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="isMB?'':'答复情况'" :label-width="isMB?'0':''" prop="">
              <el-divider v-if="isMB">答复情况</el-divider>
              <editor ref="editor"></editor>
              <el-input  v-show="false"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
       
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import editor from '@/components/common/editor';

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    editor
  },
  data() {
    return {
      data: {
      
      },
   //   api: require("@/api/bstr/bstrcp").default,
      isMB: this.$store.state.isMB,
      rules: {
    //    ReplyNotes: [{ required: true, message: "答复情况不能为空" }],
      },
    };
  },
  methods: {
    onCreateOpened(row) {
      
    },
    onEditOpened(row) {
      
    },
    onBeforeSave() {
      
    },
    onClosed() {

    },
  },
};
</script>